// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1qkcA","options":"AnswerScale_options__mLnkp","selected":"AnswerScale_selected__2m8Oy"};